<template lang="html">
  <div class="draft-current-roster" v-if="draftingTeam">
    <draft-roster :roster="roster" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import DraftRoster from './DraftRoster';

export default {
  components: {
    DraftRoster,
  },

  computed: {
    ...mapGetters({
      draftingTeam: 'draft/draftingTeam',
    }),

    roster() {
      return this.$store.getters['draft/roster'](this.draftingTeam.id);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-current-roster {
    padding: $gp;
    color: $white-color;
    height: 100%;

    h2 {
      margin-top: 0;
    }
  }
</style>
